import { ClickEvent, Image, Label, Panel, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutMobileCommOrderMessageQuickInfo } from "./autogen/AutogenLayoutMobileCommOrderMessageQuickInfo";
import { McFormFieldDefinition } from "./MobileCommMessageText";
import { ModelRow, StringUtil } from "@mcleod/core";
import { ImageName } from "@mcleod/images";

const FIELD_TYPE_CAPTION = 'CAP';
const FIELD_DEFINITION_DELIMITER = '\n';
const FIELD_TEXT_DELIMITER = '|';
const MAX_MESSAGE_TEXT_DISPLAY_LENGTH = 100;

export class MobileCommOrderMessageQuickInfo extends AutogenLayoutMobileCommOrderMessageQuickInfo {

    tableMcMessageOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const modelRow: ModelRow = tableRow.data;

        this.setupLabels(tableRow, modelRow);
        this.setupMessageText(tableRow, modelRow);
    }

    private getImageName(outbound: boolean, error: boolean, unread: boolean): ImageName {
        const errorOrNotUnread = error || !unread;
        if (outbound) {
            return errorOrNotUnread ? ImageName.messagesOutgoingOutlined : ImageName.messagesOutgoingFilled;
        }
        return errorOrNotUnread ? ImageName.messagesIncomingOutlined : ImageName.messagesIncomingFilled;
    }

    setupLabels(tableRow: TableRow, modelRow: ModelRow<any>) {
        const panelOverview = tableRow.findComponentById("panelOverview") as Panel;
        const imageMessageType = tableRow.findComponentById("imageMessageType") as Image;
        const labelMessageType = tableRow.findComponentById("labelMessageType") as Label;
        const labelMessageRead = tableRow.findComponentById("labelMessageRead") as Label;

        const outbound = modelRow.get("message_type") == 'O';
        const messageSendingStatus = modelRow.getNumber("msg_sending_status", 0);
        const network = messageSendingStatus == 1;
        const failed = messageSendingStatus == 99;
        const error = network || failed;
        const unread = messageSendingStatus < 200;

        imageMessageType.name = this.getImageName(outbound, error, unread);
        panelOverview.fontBold = unread;
        if (error) {
            labelMessageType.text = "Error";
            panelOverview.color = "error";
        } else if (outbound) {
            labelMessageType.text = "Outbound";
            panelOverview.color = "success";
        } else {
            labelMessageType.text = "Inbound";
            panelOverview.color = "primary";
        }

        if (network) {
            labelMessageRead.text = "Network";
        } else if (failed) {
            labelMessageRead.text = "Failed";
        } else if (unread) {
            labelMessageRead.text = "Unread";
        } else {
            labelMessageRead.text = "Read";
        }
    }

    setupMessageText(tableRow: TableRow, modelRow: ModelRow<any>) {
        const panelBottomRow = tableRow.findComponentById("panelBottomRow") as Panel;
        const mcFormNumber = modelRow.get("mc_form_number", 0);
        const mcFormDefinition = modelRow.get("mc_form_definition");
        const messageText: string = modelRow.get("message_text", "");
        const unread = modelRow.getNumber("msg_sending_status", 0) < 200;
        const inbound = modelRow.get("message_type", "") == 'I';
        if (panelBottomRow) {
            const isFreeform = mcFormNumber == 0;
            if (isFreeform) {
                const indexFirstLineBreak = messageText.indexOf('\n');
                const labelText = (indexFirstLineBreak > -1 && indexFirstLineBreak < MAX_MESSAGE_TEXT_DISPLAY_LENGTH)
                    ? messageText.substring(0, indexFirstLineBreak) + "..."
                    : (messageText.length > MAX_MESSAGE_TEXT_DISPLAY_LENGTH)
                        ? messageText.substring(0, MAX_MESSAGE_TEXT_DISPLAY_LENGTH) + "..."
                        : messageText;
                panelBottomRow.add(new Label({ text: labelText }));
            } else {
                const definitionList: McFormFieldDefinition[] = this.parseMcFormDefinitionFirstLine(mcFormDefinition);
                const messageTokens: string[] = messageText.split(FIELD_TEXT_DELIMITER).map((s: string) => s.trim());
                //first token is expected to be empty string as form text begins with '|'
                let i = 1;// messageToken index,
                definitionList.forEach(definition => {
                    if (definition.fieldType != FIELD_TYPE_CAPTION) {
                        definition.text = messageTokens[i];
                        i++;
                    }
                });
                definitionList.map((definition, i) => new Label({
                    text: definition.text,
                    rowBreak: false
                })).forEach(label => panelBottomRow.add(label));
                panelBottomRow.add(new Label({ text: "..." }));
            }
            panelBottomRow.fontBold = inbound && unread;
        }
    }

    buttonSeeAllMessagesOnClick(event: ClickEvent) {
        //MobileCommMessages.openSlideout({ movementId: this.mainDataSource.lastSearch.movement_id });
        //Currently this quickinfo isn't used in driver management
    }

    public parseMcFormDefinitionFirstLine(mcFormDefinition: string): McFormFieldDefinition[] {
        return mcFormDefinition.split(FIELD_DEFINITION_DELIMITER)
        .filter((s: string) => !StringUtil.isEmptyString(s))
        .map((definitionToken: String) => {
            //Uses unary + to convert string to number
            const lineNbr: number = +definitionToken.substring(0,2);
            const fieldType: string = definitionToken.substring(4,7);
            const text: string = (fieldType == FIELD_TYPE_CAPTION) ? definitionToken.substring(7).trim() : null;
            return new McFormFieldDefinition(lineNbr, fieldType, text);
        }).filter(d => d.line == 1);
    }
}
